// extracted by mini-css-extract-plugin
export default {"preloaderWrapper":"Preloader_preloaderWrapper__tkg4g","loader3d":"Preloader_loader3d__Cjcgc","favicon3d":"Preloader_favicon3d__ypsNt","spinZ":"Preloader_spinZ__PaCXV"};